module.exports = {
  container: {
    title: '가볍고 개방적이며 안전한 Web3 인프라 플랫폼',
    content:
      'BitFlow는 안정적이고 신뢰할 수 있으며 안전한 블록체인 인프라를 구축하고, 네트워크 전반에 걸쳐 주류 퍼블릭 체인 노드를 통합하고, 편리한 LSD 서약 서비스를 제공하고, 디지털 자산의 안정성과 유동성을 유지하는 것을 목표로 합니다.',
    info: '네트워크: 10+ 파트너: 20+ 커뮤니티 사용자: 20000+',
    button: '지금 서약하세요',
  },
  intro: {
    title: 'BitFlow 핵심 기능',
    coinTitle1: '비수탁 스테이킹',
    coinContent1:
      '분산 노드를 통해 사용자 자산은 사용자 자신의 지갑에 저장되며 BitFlow는 확인 키만 보관하고 사용자의 인출 키는 건드리지 않습니다.',
    coinTitle2: '유동성 서약',
    coinContent2:
      '안전하고 편리한 유동성 스테이킹 서비스 제공, 다형 오라클을 통해 주요 DEX로부터 유동성 확보, 가격 안정성 유지',
    coinTitle3: 'LSO',
    coinContent3:
      '예치금 채굴, 새로운 토큰 자금 조달 모델, 사용자는 토큰을 플랫폼에 예치하고 잠그기만 하면 채굴 수익을 얻을 수 있습니다.',
  },
  advantage: {
    title: 'BitFlow 하이라이트',
    title2: '안전하고 효율적이며 신뢰할 수 있는 LSD 서약 서비스 제공',
    content:
      'BitFlow는 Web3, DeFi 및 암호화 금융의 기본 계층인 글로벌 분산 노드 인프라를 통해 보다 협력적이고 강력한 멀티 체인 생태계를 구축하여 사용자가 위험 분산, 자동 관리 및 효율적인 방식으로 LSD 서약 서비스에 참여할 수 있도록 합니다. 디지털 자산을 통해 세계를 연결하고 디지털 생태 응용 프로그램의 새로운 시대를 만듭니다.',
  },
  more: {
    title: '효율적이고 편리한 혁신적인 모델',
    content:
      'BitFlow를 통해 사용자는 스테이크 토큰을 사용하여 BitFlow 통합 Web3 애플리케이션 및 DeFi 서비스에 액세스하고 탐색할 수 있습니다.',
    button: '자세한 내용',
    boxTitle1: '다중 체인 서약',
    boxContent1:
      '현재 협력 퍼블릭 체인에는 ETH, BNB, Polygon, ARB, SUI 등이 있으며 앞으로 더 많은 네트워크가 지원될 예정입니다.',
    boxTitle2: '탈중앙화',
    boxContent2:
      '서약 사용자와 노드 운영자는 자유롭게 매칭되며 생성, 출금 및 보상 위임은 모두 실행 계층에서 스마트 계약으로 처리됩니다.',
    boxTitle3: '노드 관리',
    boxContent3:
      '사용자가 노드 관리를 위해 자체 검증자를 배포하고 클라우드 서비스 지원을 제공하며 동기화 시간을 절약하도록 지원합니다.',
    boxTitle4: '블록 모니터링',
    boxContent4:
      'BitFlow는 24시간 실시간으로 모든 노드와 API 서비스를 모니터링하고 사용자에게 보다 포괄적이고 직관적인 데이터를 제공합니다.',
    boxTitle5: '복리 소득',
    boxContent5:
      '디지털 자산의 유동성을 해제하기 위해 사용자는 스테이킹, 유동성 채굴 및 초대 리베이트를 통해 여러 가지 혜택을 얻을 수 있습니다.',
  },
  ecology: {
    title: '미래를 약속하는 BitFlow 생태계',
    content: 'Web3 애플리케이션 시나리오 및 DeFi 서비스 살펴보기',
  },
  media: '글로벌 파트너',
  bitFlowIntro: {
    content:
      '분산된 나선형 영구 운동 메커니즘의 세계 최초의 완벽한 토큰 경제 모델로 지속 가능한 현금 인출기를 생산하는 분산되고 분산된 가장 강력한 웹3 인프라 플랫폼을 만듭니다.',
  },
  transaction: {
    wallet: '월렛 로그인',
    assets: {
      title: '내 컴퓨팅 파워',
      content: '내 컴퓨팅 파워',
      text1: '보증금',
      text2: '거래',
      text3: '옮기다',
      text4: '대사',
      text5: '자산',
    },
    place: {
      tab1: '주문',
      tab2: '재투표하다',
      text1: 'USDT 잔액',
      text2: '흐름 균형',
      mask: '상위 월렛을 바인딩하지 않아 주문을 할 수 없습니다. 바로 바인딩하시겠습니까?',
      maskLight: '바로 바인딩하시겠습니까?',
      payNeed: '지불 필요',
      confirm: '주문 확인',
      contact: '문의하기',
      maskInputTitle: '계정 연결',
      maskInputContent: '유효한 계정이 연결된 경우에만 연결이 성공할 수 있습니다.',
      placeholder: '유효한 연결된 계정을 입력하세요.',
      confirmLink: '링크 확인',
    },
  },
}
